/**
 * Legal content registry — maps each locale to its translated legal documents.
 *
 * Legal documents are maintained only in pt-BR (primary, Brazilian market) and
 * en (international fallback). Any other locale falls back to English — keeping
 * legal texts in fewer languages avoids stale translations of binding documents.
 */
import type { LegalContent } from './types';
import { legalPtBR } from './pt-BR';
import { legalEn } from './en';
import type { Locale } from '../i18n';

const legalContent: Partial<Record<Locale, LegalContent>> = {
  'pt-BR': legalPtBR,
  en: legalEn,
};

export function getLegalContent(locale: Locale): LegalContent {
  return legalContent[locale] ?? legalEn;
}

export type { LegalContent, LegalDocument, LegalSection } from './types';
